module.exports = __webpack_public_path__ + "static/media/movie_category.7fe2613c.jpg";